import type { ReactNode } from 'react';

export const symbol_egg: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M281.5-201.5Q200-283 200-400q0-77 25.5-155t66-141.5Q332-760 382-800t98-40q49 0 98.5 40t90 103.5Q709-633 734.5-555T760-400q0 117-81.5 198.5T480-120q-117 0-198.5-81.5ZM650-230.2q70-70.2 70-169.8 0-66-22.5-136.5t-58.17-128.84q-35.68-58.33-78-96.5Q519-800 480-800t-81.5 37.5q-42.5 37.5-78 96t-58 129.5Q240-466 240-400q0 99.6 70 169.8Q380-160 480-160t170-70.2ZM505-241q8.5 0 14.25-6t5.75-14q0-8-5.75-14T505-281q-58.33 0-99.17-40.83Q365-362.67 365-421q0-8.5-6-14.25T345-441q-8 0-14 5.75T325-421q0 74.7 52.65 127.35Q430.3-241 505-241Zm-25-239Z"
		/>
	</svg>
);
